import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'markant-platform-complete-profile-dialog',
  standalone: true,
  imports: [MarkantElementsModule, TranslocoModule],
  templateUrl: './complete-profile-dialog.component.html',
  styleUrl: './complete-profile-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteProfileDialogComponent {
  completeProfile = output();
  close = output();
}
